export const name = 'translations' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
